import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createOrganisationAccountingsSchemas } from 'shared/db/validation/schema/organisationAccountings';
import { Validator } from 'shared/db/validation/validator';
import {
    OrganisationAccountingsRawRecord,
    OrganisationAccountingsUpdateRawRecord,
} from 'shared/types/OrganisationAccountings';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { OrganisationAccountingsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createOrganisationAccountingsSchemas();

const addValidator = createDBEntityValidator<OrganisationAccountingsRawRecord>(
    schemas.add,
);
const updateValidator =
    createDBEntityValidator<OrganisationAccountingsUpdateRawRecord>(
        schemas.update,
    );
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-organisation-accountings'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createOrganisationAccountingsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const organisationAccountingsInputValidation: OrganisationAccountingsDBValidation =
    {
        add: createOrganisationAccountingsInputValidation(
            addValidator,
            validationStrategy,
        ),
        update: createOrganisationAccountingsInputValidation(
            updateValidator,
            validationStrategy,
        ),
        delete: createOrganisationAccountingsInputValidation(
            deleteValidator,
            validationStrategy,
        ),
    };
